import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IAlertsModuleConfig
 * @example
 * ```typescript
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: AlertsModuleConfigToken, useValue: alertsModuleConfig },
 * ],
 * ```
 */
const AlertsModuleConfigToken = new InjectionToken('alerts_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { AlertsModuleConfigToken };


//# sourceMappingURL=mt-ng2-alerts-module-config.js.map